import { createContext } from 'react';

import type {
  DatasetKey,
  Datasets,
  Event as TransactionalEvent,
} from '@infinex/types';

export type TransactionalEventHandler = (event: TransactionalEvent) => void;
export type TransactionalEventUnsubscribe = () => void;

export type UserContextType = {
  streamDataset: <K extends DatasetKey>(
    key: K,
    timeoutMs: number,
    signal: AbortSignal
  ) => Promise<AsyncIterable<Datasets[K]>>;

  subscribeToTransactionalEvents: (
    handler: TransactionalEventHandler
  ) => TransactionalEventUnsubscribe;
};

// Default no-op async iterable for when context is used outside UserProvider
async function* emptyGenerator() {}

export const UserContext = createContext<UserContextType>({
  streamDataset: async () => emptyGenerator(),
  subscribeToTransactionalEvents: () => () => {},
});
